var map = {
	"./configBEL.json": "ffae",
	"./configCHN.json": "98c3",
	"./configFRA.json": "b3be",
	"./configGBR.json": "c277",
	"./configIND.json": "18fb",
	"./configITA.json": "d7eb",
	"./configMEA.json": "70c0",
	"./configNLD.json": "4f04",
	"./configPLZ.json": "8e37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ae26";